<template>
  <v-container class="services-wrapper">
    <!-- Encabezado -->
    <div class="services-header">
      <h2 class="services-title">Nuestros <span class="highlight">Servicios</span></h2>
      <p class="services-subtitle">Soluciones energéticas innovadoras para un futuro sostenible</p>
      <v-divider class="divider"></v-divider>
    </div>

    <!-- Grid de servicios -->
    <v-row class="services-grid" justify="center">
      <v-col
          v-for="(service, index) in services"
          :key="index"
          cols="12"
          sm="10"
          md="6"
          lg="4"
          class="service-col"
      >
        <v-card
            class="service-card mx-auto"
            :class="`card-${index % 3}`"
            elevation="4"
            width="100%"
            max-width="360"
            @mouseenter="hoveredCard = index"
            @mouseleave="hoveredCard = null"
        >
          <div class="card-icon">
            <v-icon :icon="service.icon" size="60"></v-icon>
          </div>

          <v-card-title class="card-title">{{ service.title }}</v-card-title>

          <v-card-text class="card-text">
            {{ service.description }}
          </v-card-text>

          <div class="card-features">
            <v-chip
                v-for="(feature, i) in service.features"
                :key="i"
                class="feature-chip"
                label
                size="small"
            >
              {{ feature }}
            </v-chip>
          </div>

          <v-card-actions class="card-actions">
            <v-btn
                class="action-btn"
                variant="outlined"
                size="large"
                @click="openModal(service)"
            >
              Consultar
              <v-icon end icon="mdi-arrow-right"></v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Modal de detalle del servicio -->
    <v-dialog v-model="modal" max-width="800">
      <v-card v-if="selectedService" class="service-modal">
        <v-card-title class="modal-header">
          <span class="modal-title">{{ selectedService.title }}</span>
          <v-btn icon @click="modal = false" class="close-btn">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="modal-content">
          <v-row>
            <v-col cols="12" md="6" class="modal-image-col">
              <div class="modal-icon-wrapper">
                <v-icon size="100" class="modal-icon">{{ selectedService.icon }}</v-icon>
              </div>
              <img
                  :src="selectedService.image"
                  :alt="selectedService.title"
                  class="modal-image"
                  v-if="selectedService.image"
              >
            </v-col>

            <v-col cols="12" md="6">
              <h3 class="modal-subtitle">Descripción detallada</h3>
              <p class="modal-description">{{ selectedService.detailedDescription }}</p>

              <h3 class="modal-subtitle">Beneficios clave</h3>
              <ul class="benefits-list">
                <li v-for="(benefit, i) in selectedService.benefits" :key="i">
                  <v-icon small color="success" class="mr-2">mdi-check-circle</v-icon>
                  {{ benefit }}
                </li>
              </ul>

              <div class="modal-features">
                <h3 class="modal-subtitle">Características principales</h3>
                <div class="features-grid">
                  <v-chip
                      v-for="(feature, i) in selectedService.features"
                      :key="i"
                      class="feature-chip-modal"
                      color="primary"
                      label
                  >
                    {{ feature }}
                  </v-chip>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="modal-actions">
          <v-btn
              color="primary"
              size="large"
              @click="contactAbout(selectedService.title)"
              block
          >
            <v-icon left>mdi-email</v-icon>
            Solicitar información
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: 'Servicios',
  data() {
    return {
      hoveredCard: null,
      modal: false,
      selectedService: null,
      services: [
        {
          icon: 'mdi-solar-panel-large',
          title: 'Energía Solar',
          description: 'Instalación de sistemas fotovoltaicos residenciales e industriales.',
          detailedDescription: 'Nuestros sistemas de energía solar fotovoltaica ofrecen una solución sostenible y económica para la generación de electricidad. Utilizamos paneles de última generación con garantías extendidas y sistemas de monitorización inteligente.',
          image: require('@/assets/solar-panels.jpeg'),
          features: ['Paneles solares', 'Inversores', 'Baterías', 'Monitoreo'],
          benefits: [
            'Reducción de hasta 80% en tu factura eléctrica',
            'Retorno de inversión en 3-5 años',
            'Sistemas con garantía de 25 años',
            'Independencia energética'
          ]
        },
        // {
        //   icon: 'mdi-wind-turbine',
        //   title: 'Energía Eólica',
        //   description: 'Sistemas de turbinas eólicas para generación de energía.',
        //   detailedDescription: 'Implementamos soluciones eólicas adaptadas a diferentes escalas, desde pequeños generadores para viviendas hasta parques eólicos completos para empresas. Realizamos estudios de viabilidad previos para garantizar el máximo rendimiento.',
        //   image: require('@/assets/wind-turbine.jpeg'),
        //   features: ['Turbinas', 'Estudios de viabilidad', 'Instalación', 'Mantenimiento'],
        //   benefits: [
        //     'Energía limpia las 24 horas',
        //     'Sistemas silenciosos y eficientes',
        //     'Bajo mantenimiento',
        //     'Ideal para zonas con vientos constantes'
        //   ]
        // },
        {
          icon: 'mdi-leaf',
          title: 'Consultoría Energética',
          description: 'Asesoramiento en prácticas de energía renovable.',
          detailedDescription: 'Nuestro equipo de expertos analiza tu consumo energético y desarrolla un plan personalizado para optimizar tus recursos, reducir costos y mejorar tu huella ambiental. Incluye auditorías energéticas y planificación estratégica.',
          image: require('@/assets/consulting.jpeg'),
          features: ['Auditorías', 'Planificación', 'Certificaciones', 'Optimización'],
          benefits: [
            'Ahorros comprobados en consumo energético',
            'Planificación a corto, mediano y largo plazo',
            'Asesoramiento para certificaciones verdes',
            'Análisis de retorno de inversión'
          ]
        },
        {
          icon: 'mdi-battery-charging-high',
          title: 'Almacenamiento',
          description: 'Sistemas de almacenamiento energético de última generación.',
          detailedDescription: 'Ofrecemos soluciones de almacenamiento con baterías de litio de alto rendimiento y sistemas híbridos que te permiten maximizar el aprovechamiento de tu energía renovable y garantizar suministro durante cortes.',
          image: require('@/assets/battery-storage.jpeg'),
          features: ['Baterías Li-ion', 'Sistemas híbridos', 'Backup', 'Gestión'],
          benefits: [
            'Autonomía energética las 24 horas',
            'Protección contra apagones',
            'Optimización del autoconsumo',
            'Tecnología de punta con garantía extendida'
          ]
        },
        {
          icon: 'mdi-home-automation',
          title: 'Autoconsumo',
          description: 'Soluciones llave en mano para energía propia.',
          detailedDescription: 'Implementamos sistemas completos de autoconsumo que incluyen diseño, trámites legales, instalación y puesta en marcha. Nos encargamos de todo el proceso para que solo tengas que disfrutar de los beneficios.',
          image: require('@/assets/solar-home.jpeg'),
          features: ['Diseño', 'Legalización', 'Puesta en marcha', 'Financiación'],
          benefits: [
            'Soluciones completas llave en mano',
            'Asesoramiento en trámites y permisos',
            'Opciones de financiamiento',
            'Monitoreo remoto del sistema'
          ]
        },
        {
          icon: 'mdi-chart-areaspline',
          title: 'Monitorización',
          description: 'Sistemas inteligentes para controlar tu consumo.',
          detailedDescription: 'Nuestros sistemas de monitorización te permiten conocer en tiempo real tu producción y consumo energético, con alertas personalizables y reportes automatizados para una gestión eficiente de tus recursos.',
          image: require('@/assets/monitoring.jpeg'),
          features: ['IoT', 'Analítica', 'Alertas', 'Reportes'],
          benefits: [
            'Control en tiempo real desde tu móvil',
            'Detección temprana de anomalías',
            'Reportes personalizados',
            'Integración con sistemas existentes'
          ]
        }
      ]
    };
  },
  methods: {
    openModal(service) {
      this.selectedService = service;
      this.modal = true;
    },
    contactAbout(service) {
      console.log(`Contacto solicitado para: ${service}`);
      // Aquí puedes implementar la lógica para redirigir a un formulario de contacto
      // o mostrar otro modal con el formulario
      this.modal = false;
    }
  }
};
</script>

<style scoped>
.services-wrapper {
  max-width: 1400px;
  padding: 80px 24px;
  margin: 0 auto;
}

.services-header {
  text-align: center;
  margin-bottom: 60px;
}

.services-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #0C594B;
  margin-bottom: 16px;
  line-height: 1.2;
}

.highlight {
  color: #0A9A8A;
  position: relative;
}

.highlight::after {
  content: '';
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background-color: rgba(10, 154, 138, 0.2);
  z-index: -1;
}

.services-subtitle {
  font-size: 1.1rem;
  color: #555;
  max-width: 600px;
  margin: 0 auto 24px;
}

.divider {
  width: 100px;
  height: 3px;
  background-color: #0A9A8A;
  margin: 0 auto;
  opacity: 1;
}

/* Grid con espaciado perfecto */
.services-grid {
  margin: 0 -12px;
  width: calc(100% + 24px);
}

.service-col {
  padding: 12px;
  display: flex;
  justify-content: center;
}

.service-card {
  height: 100%;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  padding: 40px 24px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.service-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.card-icon {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #0C594B 0%, #0A9A8A 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  color: white;
}

.card-title {
  font-size: 1.5rem !important;
  font-weight: 600 !important;
  color: #0C594B !important;
  margin-bottom: 16px !important;
  text-align: center;
  padding: 0 !important;
  width: 100%;
}

.card-text {
  color: #555 !important;
  font-size: 1rem !important;
  line-height: 1.6 !important;
  margin-bottom: 24px !important;
  padding: 0 12px !important;
  text-align: center;
}

.card-features {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-bottom: 32px;
  width: 100%;
}

.feature-chip {
  background-color: #f5f5f5 !important;
  color: #0C594B !important;
  font-weight: 500 !important;
}

.card-actions {
  width: 100%;
  padding: 0 !important;
  justify-content: center;
}

.action-btn {
  border-color: #0C594B !important;
  color: #0C594B !important;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
  padding: 8px 24px !important;
  transition: all 0.3s ease;
}

.action-btn:hover {
  background-color: #0C594B !important;
  color: white !important;
}

/* Variantes de color para las tarjetas */
.service-card.card-0 {
  border-top: 4px solid #0C594B;
}

.service-card.card-1 {
  border-top: 4px solid #0A9A8A;
}

.service-card.card-2 {
  border-top: 4px solid #308C7B;
}

/* Estilos del modal */
.service-modal {
  border-radius: 12px;
  overflow: hidden;
}

.modal-header {
  background: linear-gradient(135deg, #0C594B 0%, #0A9A8A 100%);
  color: white;
  padding: 24px;
  position: relative;
}

.modal-title {
  font-size: 1.8rem;
  font-weight: 600;
}

.close-btn {
  position: absolute;
  right: 16px;
  top: 16px;
  color: white;
}

.modal-content {
  padding: 24px;
}

.modal-image-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.modal-icon-wrapper {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #0C594B 0%, #0A9A8A 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.modal-image {
  width: 100%;
  border-radius: 8px;
  max-height: 250px;
  object-fit: cover;
}

.modal-subtitle {
  font-size: 1.3rem;
  color: #0C594B;
  margin: 24px 0 12px 0;
  font-weight: 600;
}

.modal-description {
  color: #555;
  line-height: 1.6;
  margin-bottom: 16px;
}

.benefits-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 24px;
}

.benefits-list li {
  padding: 8px 0;
  display: flex;
  align-items: center;
}

.features-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.feature-chip-modal {
  margin: 4px;
}

.modal-actions {
  padding: 16px 24px;
  justify-content: center;
}

/* Responsive - Comportamiento de columnas */
@media (min-width: 960px) {
  /* 3 columnas en desktop */
  .service-col {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  /* 2 columnas en tablet */
  .service-col {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

@media (max-width: 599px) {
  /* 1 columna en móvil */
  .service-col {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 600px) {
  .services-wrapper {
    padding: 40px 16px;
  }

  .services-title {
    font-size: 1.8rem;
  }

  .service-card {
    padding: 30px 16px;
  }

  .card-icon {
    width: 80px;
    height: 80px;
  }

  .services-grid {
    margin: 0 -8px;
    width: calc(100% + 16px);
  }

  .service-col {
    padding: 8px;
  }

  /* Responsive para el modal */
  .modal-title {
    font-size: 1.5rem;
  }

  .modal-icon-wrapper {
    width: 120px;
    height: 120px;
  }

  .modal-icon {
    font-size: 60px !important;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 16px;
  }

  .modal-title {
    font-size: 1.3rem;
    padding-right: 40px;
  }

  .modal-content {
    padding: 16px;
  }

  .modal-subtitle {
    font-size: 1.1rem;
    margin: 16px 0 8px 0;
  }
}
</style>